import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import B2BTheme, { EPRTheme, ExchangeTheme } from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { whyDidYouRender } from '../wdyr';
import { App } from './App';
import { getRoutes } from './routes';
import { STOREFRONT_TYPES } from './utils';

NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext({
    opts: {
      federation: true
    }
  });

  client.setExperienceRoutes(getRoutes());

  if (client.serverData.themeName === STOREFRONT_TYPES.EPROCUREMENT) {
    client.setTheme({ name: STOREFRONT_TYPES.EPROCUREMENT, template: EPRTheme });
  } else if (client.serverData.themeName === STOREFRONT_TYPES.EXCHANGE) {
    client.setTheme({ name: STOREFRONT_TYPES.EXCHANGE, template: ExchangeTheme });
  } else if (client.serverData.themeName === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  }
  client.render(<App
    prefetchPip={client.featureSwitches.prefetchPip}
    productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
  />);
});
